import { client } from 'pioneira-ui';

export default {
  namespaced: true,
  actions: {
    async getFrontendVersion() {
      return await client.get('/api/config/frontend-version');
    },
  },
};
